import { render, staticRenderFns } from "./rowsnumber.vue?vue&type=template&id=2e15ec44&"
import script from "./rowsnumber.vue?vue&type=script&lang=js&"
export * from "./rowsnumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports